import { Component, input } from '@angular/core';
import { MatPrefix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';

@Component({
  imports: [MatIcon, MatPrefix],
  selector: 'avs-li-copyright-footer',
  standalone: true,
  templateUrl: './copyright-footer.component.html',
})
export class CopyrightFooterComponent {
  isMobile = input(false);
  protected year = new Date().getFullYear();
}
